import React, {useMemo} from 'react';

import dataCollectorStatuses from '../../../consts/dataCollector/dataCollectorStatuses.ts';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import useIsMobileViewport from '../../../hooks/useIsMobileViewport';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import {IconCopy, IconEdit, IconLock, IconLockOpen, IconTrashCan} from '../../Icons';
import OptionsMenu from '../OptionsMenu';
import DataCollectorMobileOptionsMenu from './DataCollectorMobileOptionsMenu';

const DataCollectorOptionsMenu = ({record, dataSource, handlers, isForHeader, isDisabled, customTrigger}) => {
    const isMobile = useIsMobileViewport();
    const isBlocked = dataCollectorStatuses.Blocked === record?.status;
    const localizedStrings = getLocalizedStrings();

    const menu = useMemo(() => {
        const items = isForHeader
            ? [
                  {
                      key: 'unlock-header',
                      icon: <IconLockOpen />,
                      label: localizedStrings[localizationKeys.DC_OPTIONS_MENU_UNBLOCK],
                      onClick: () => handlers.handleUnlockStatus(record),
                  },
                  {
                      key: 'block-header',
                      icon: <IconLock />,
                      label: localizedStrings[localizationKeys.DC_OPTIONS_MENU_BLOCK],
                      onClick: () => handlers.handleLockStatus(record),
                  },
              ]
            : [
                  {
                      key: 'edit',
                      icon: <IconEdit />,
                      label: localizedStrings[localizationKeys.DC_OPTIONS_MENU_EDIT],
                      isVisible: true,
                      onClick: () => handlers.handleEdit(record),
                  },
                  {
                      key: 'toggle-status',
                      icon: isBlocked ? <IconLockOpen /> : <IconLock />,
                      label: isBlocked
                          ? localizedStrings[localizationKeys.DC_OPTIONS_MENU_UNBLOCK]
                          : localizedStrings[localizationKeys.DC_OPTIONS_MENU_BLOCK],
                      isVisible: true,
                      onClick: () =>
                          isBlocked ? handlers.handleUnlockStatus([record.id]) : handlers.handleLockStatus([record.id]),
                  },
                  {
                      key: 'copy',
                      icon: <IconCopy />,
                      label: localizedStrings[localizationKeys.DC_OPTIONS_MENU_COPY],
                      isVisible: true,
                      onClick: () => handlers.handleCopy(record),
                  },
                  {
                      key: 'delete',
                      danger: true,
                      icon: <IconTrashCan />,
                      label: localizedStrings[localizationKeys.DC_OPTIONS_MENU_DELETE],
                      isVisible: true,
                      onClick: () => handlers.handleDelete(record),
                      isActionConfirmRequired: true,
                  },
              ];

        return items.filter((item) => item.isVisible !== false);
    }, [isForHeader, isBlocked, record, handlers, localizedStrings]);

    if (isMobile && !isForHeader) {
        return (
            <DataCollectorMobileOptionsMenu
                menuItems={menu}
                record={record}
                disabled={isDisabled}
                customTrigger={customTrigger}
            />
        );
    }

    return (
        <OptionsMenu
            menuItems={menu}
            record={record}
            dataSource={dataSource}
            disabled={isDisabled}
            customTrigger={customTrigger}
        />
    );
};

export default DataCollectorOptionsMenu;
